module.exports = __webpack_public_path__ + "img/BIT_white07.2f86f602.jpg";